import {
  Box,
  Flex,
  HStack,
  IconButton,
  Button,
  useDisclosure,
  useColorModeValue,
  Stack,
} from '@chakra-ui/react';
import { HamburgerIcon, CloseIcon, DownloadIcon } from '@chakra-ui/icons';
import { Link } from 'react-scroll';
import resume from '../profile/Rutuvik-Resume.pdf';


export default function Navbar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const linkStyles={color:'white', fontWeight:'semibold', fontSize:'20px', cursor:"Pointer"};
  const handleMouseEnter=(e)=>{
    e.target.style.color='black'
  }
  const handleMouseLeave=(e)=>{
    e.target.style.color='white'
  }

  // const handleClick=()=>{
  //   fetch("Rutuvik-Resume.pdf").then((res)=>{
  //     res.blob().then((blob)=>{
  //       const fileUrl = window.URL.createObjectURL(blob);
  //       let file = document.createElement("a");
  //       file.href = fileUrl;
  //       file.download = "Rutuvik-Resume.pdf";
  //       file.click();
  //     });
  //     window.location.href="https://drive.google.com/file/d/1J_Xvq2-tQGlo9SmrRFGZIA00VvZnTno8/view?usp=sharing"
  //   })
  // }

  return (
    <>
      <Box bg={useColorModeValue('secondary')} px={4} id="nav-menu" position={'sticky'} zIndex='2' top={'0'}>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <IconButton
            size={'md'}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={'Open Menu'}
            display={{ md: 'none' }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={'center'}>
            <HStack
              as={'nav'}
              spacing={4}
              alignItems={'center'}
              display={{ base: 'none', md: 'flex' }}>
              <Link className='nav-link home' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} activeClass="active" duration={500} smooth={true} to='home' style={linkStyles}>Home</Link>
              <Link className='nav-link about' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} activeClass="active" duration={500} smooth={true} to='about' style={linkStyles}>About</Link>
              <Link className='nav-link skills' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} activeClass="active" duration={500} smooth={true} to='skills' style={linkStyles}>Skills</Link>
              <Link className='nav-link projects' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} activeClass="active" duration={500} smooth={true} to='projects' style={linkStyles}>Projects</Link>
              <Link className='nav-link contact' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} activeClass="active" duration={500} smooth={true} to='contact' style={linkStyles}>Contact</Link>
            </HStack>
          </HStack>
            <Button id="resume-button-1" className='nav-link resume' marginRight={'10px'} _hover={{bg:'black', color:'white'}}><a a href={resume} download="Rutuvik-Resume.pdf" id='resume-link-1' target='_blank' rel="noreferrer" onClick={()=>window.open("https://drive.google.com/file/d/1J_Xvq2-tQGlo9SmrRFGZIA00VvZnTno8/view?usp=sharing")}>Resume</a>  <DownloadIcon ml={'2px'}/></Button>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: 'none' }}>
            <Stack as={'nav'} spacing={4}>
            <Link className='nav-link home' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} activeClass="active" duration={500} smooth={true} to='home' style={linkStyles}>Home</Link>
              <Link className='nav-link about' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} activeClass="active" duration={500} smooth={true} to='about' style={linkStyles}>About</Link>
              <Link className='nav-link skills' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} activeClass="active" duration={500} smooth={true} to='skills' style={linkStyles}>Skills</Link>
              <Link className='nav-link projects' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} activeClass="active" duration={500} smooth={true} to='projects' style={linkStyles}>Projects</Link>
              <Link className='nav-link contact' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} activeClass="active" duration={500} smooth={true} to='contact' style={linkStyles}>Contact</Link>
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
}